import { Brand } from "@org-avp/avp-avengers-project-service-api";

export enum TargetMaterialMode {
  COLOR_FAMILY = "COLOR_FAMILY",
  DEFAULT = "DEFAULT",
}

export const getTargetMaterialMode: (brand: Brand) => TargetMaterialMode = (brand: Brand) => {
  switch (brand) {
    case Brand.AUDI_PLUS:
    case Brand.BENTLEY:
    case Brand.LAMBORGHINI:
      return TargetMaterialMode.COLOR_FAMILY;
    default:
      return TargetMaterialMode.DEFAULT;
  }
};

export const BRAND_USING_AUTOMATED_LOGIC_STRING_GENERATION: Brand[] = [
  Brand.BENTLEY,
];
export const usesAutomatedLogicStringGeneration: (brand: Brand) => boolean =
  (brand: Brand) => BRAND_USING_AUTOMATED_LOGIC_STRING_GENERATION.includes(brand);
